import React from "react";

import { cn } from "@/lib/utils";
import CustomTooltip from "@/components/shared/CustomTooltip";
import Skeleton from "@/components/shared/Skeleton";

const FlowUsageStat = ({ label, scope, hint, used, max, loading = false }) => {
  const atLimit = max > 0 && used >= max;

  return (
    <CustomTooltip text={hint}>
      <div className="min-w-[148px] rounded-lg border border-border-primary bg-background-secondary px-3 py-2">
        <span className="block text-[11px] font-medium text-text-secondary">{label}</span>
        {loading ? (
          <Skeleton className="mt-1 h-4 w-20" />
        ) : (
          <span className="mt-0.5 block text-[13px] font-semibold tabular-nums text-text-primary">
            <span
              className={cn(
                "text-[13px] font-semibold tabular-nums",
                atLimit && "text-tone-amber"
              )}
            >
              {used} of {max}
            </span>{" "}
            <span className="font-normal text-text-secondary">{scope}</span>
          </span>
        )}
      </div>
    </CustomTooltip>
  );
};

export default FlowUsageStat;
